<template>
  <div>
    <Header/>
    <div class="app-wrapp" v-touch:swipe="swipeHandler">
      <transition name="fade" mode="out-in">
        <component
          @updateCurrent="current = 2"
          :is="current === 1 ? 'Welcome' : 'Slider'"/>
      </transition>
    </div>
  </div>
</template>

<script>
import Welcome from '@/components/Welcome/Welcome'
import Header from '@/components/Header/Header'
import Slider from '@/components/Slider/Slider'

function debounce (func, wait, immediate) {
  let timeout
  return function () {
    const context = this; const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

let scrollTo

export default {
  name: 'Home',
  data () {
    return {
      current: 1
    }
  },
  methods: {
    swipeHandler (e) {
      if (this.$store.getters.isScreenLocked) return

      if (e === 'top') this.current = 2

      if (e === 'bottom') {
        if (document.querySelector('html').scrollTop <= 0) {
          this.current = 1
        }
      }
    }
  },
  mounted () {
    scrollTo = debounce((event) => {
      if (this.$store.getters.isScreenLocked) return
      this.current = event.deltaY > 0 ? 2 : 1
    }, 500, true)

    window.addEventListener('wheel', scrollTo)
  },
  destroyed () {
    window.removeEventListener('wheel', scrollTo)
  },
  components: {
    Welcome, Header, Slider
  }
}
</script>
